<template>
  <div id="scroll" :class="{ 'bg-white': true, 'property-detail': true, 'rent-property-detail': isRentalPropertyDetail }">
    <navbar />
    <section class="wrapper" v-if="propertiesDetails">
      <div id="property-detail_outer_wrapper">
      <div class="property-detail_wrapper" id="property-detail_wrapper">
        <p class="category sp"><span>{{$t(propertiesDetails.type)}}</span>{{$t(propertiesDetails.property_category)}}</p>
        <p class="category sp">{{$t(propertiesDetails.newStatus)}}</p>
        <h2 class="sp">{{propertiesDetails.property_name}}</h2>
        <slick
          ref="main"
          class="slide-main"
          :options="slickOptions1">
          <li v-for="(itemSub, indexSub) in propertiesDetails.properties_images" :key="indexSub">
            <div :class="tallClass(decodeURI(itemSub.url))">
              <img :src="decodeURI(itemSub.url)" alt="photo1" @click="openLightBox(indexSub.url)">
              <div v-if="itemSub.label" class="label">{{ itemSub.label }}</div>
            </div>
          </li>
        </slick>

        <slick
          ref="thumbnail"
          class="slide-thum"
          :options="slickOptions2">
          <li v-for="(itemSub, indexSub) in propertiesDetails.properties_images" :key="indexSub">
            <div :class="tallClass(decodeURI(itemSub.url))">
              <img :src="decodeURI(itemSub.url)" alt="photo1">
            </div>
          </li>
        </slick>
        <div class="movie-wrap" v-if="propertiesDetails.property_video">
          <iframe :src="propertiesDetails.property_video[0].videos[0].url" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
        </div>
        <div class="property-detail_inner" id="property-detail_inner" v-resize @resize="onResize">
          <vue-sticky-sidebar containerSelector=".property-detail_wrapper" innerWrapperSelector='.sidebar__inner' :minWidth="780">
          <p class="category pc"><span>{{$t(propertiesDetails.type)}}</span>{{$t(propertiesDetails.property_category)}}</p>
          <p class="category pc" v-if="propertiesDetails.newStatus">{{$t(propertiesDetails.newStatus)}}</p>
          <h2 class="pc">{{propertiesDetails.property_name}}</h2>
          <property-detail-summary :propertyDetail="propertiesDetails" />
          <p class="property-detail_text"  v-html="description"></p>
          <div class="property-detail_button">
            <button type="button" @click="favoriteProperty(propertiesDetails.id)" v-bind:class="{ 'registered': isHidden }" name="favorit" class="orange_btn">
              <i class="icon-favorit" :style="iconFavorit"></i>
              <span v-if="!isHidden">{{$t('お気に入り')}}</span>
              <span v-else>{{$t('お気に入りを解除')}}</span>
            </button>
            <button type="button" @click="contactUs(propertiesDetails.property_name)" class="brown_btn"><i class="icon-submit" :style="iconSubmit"></i><span>{{$t('contact')}}</span></button>
          </div>
          </vue-sticky-sidebar>
        </div>
      </div>
      </div>
      <h3>{{$t('物件概要')}}</h3>
      <property-detail-table :propertyDetail="propertiesDetails" />
      <h3>{{$t('アクセス')}}</h3>
      <div class="map-wrap">
        <iframe :src="propertiesDetails.google_map_url" height="400" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </div>
      <dl class="access">
        <dt v-html="street_address"></dt>
        <dd v-html="nearest_station"></dd>
      </dl>
      <div class="agency-wrap" v-if="isCompanyInformationShown">
        <h3>{{ $t('h3_agency') }}</h3>
        <dl class="agency">
          <dt>{{ company.name }}</dt>
          <dd v-html="companyDescription"></dd>
        </dl>
      </div>
      <div class="back">
        <a @click="returnList" class="white_btn"><span>{{$t('一覧ページへ戻る')}}</span></a>
      </div>
      <div class="chatbox" v-if="propertiesDetails.chatbot_url">
      <div class="classposi">
        <div class="chatonoff" @click="chatBoxStatus = !chatBoxStatus">
          <a href="javascript:void(0)">
            <p class="chatboticon" :style="iconBefore"></p>
          </a>
          </div>
          <div :class="chatBoxStatus === true ? 'on' : 'off'">
            <iframe id="inline-frame" :src="propertiesDetails.chatbot_url"></iframe>
          </div>
      </div>
      </div>
    </section>
    <section v-show="page404" >
      <page4040/>
    </section>
    <footerClient v-if="propertiesDetails"/>
    <ImageLightBox ref="lightbox" :media="lightboxImages" :showLightBox="false" :showThumbs="false" :showCaption="false" :showFooterCount="false" v-if="lightboxImages" />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import vueStickySidebar from 'vue-sticky-sidebar'
import page4040 from './components/404'
import { mapActions, mapGetters } from 'vuex'
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import propertyDetailSummary from './components/property-detail-summary.vue'
import propertyDetailTable from './components/property-detail-table.vue'
import ImageLightBox from 'vue-image-lightbox'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'

export default {
  data () {
    return {
      chatBoxStatus: false,
      slickOptions1: {
        arrows: false,
        fade: true,
        asNavFor: '.slide-thum'
      },
      slickOptions2: {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        swipeToSlide: true,
        focusOnSelect: true,
        asNavFor: '.property-detail .slide-main',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>'
      },
      iconFavorit: {
        background: `url(${require('@/assets/img/client/icon-favorit.png')}) left top no-repeat`
      },
      iconSubmit: {
        background: `url(${require('@/assets/img/client/icon-submit.png')}) left top no-repeat`
      }
    }
  },
  components: {
    navbar,
    footerClient,
    vueStickySidebar,
    page4040,
    Slick,
    propertyDetailSummary,
    propertyDetailTable,
    ImageLightBox
  },
  computed: {
    ...mapGetters('propertyClient', ['propertiesDetails', 'favorite', 'page404', 'company']),
    isHidden: function () {
      if (this.favorite === true) {
        return true
      } else {
        return false
      }
    },
    isRentalPropertyDetail: function () {
      return ['residential-property-detail', 'commercial-property-detail'].includes(this.$route.params.type)
    },
    description () {
      if (this.propertiesDetails.copy) {
        return this.propertiesDetails.copy.replace(/\n/g, '<br />')
      }
      return null
    },
    street_address () {
      if (this.propertiesDetails.street_address) {
        return this.propertiesDetails.street_address.replace(/\n/g, '<br />')
      }
      return null
    },
    nearest_station () {
      if (this.propertiesDetails.nearest_station) {
        return this.propertiesDetails.nearest_station.replace(/\n/g, '<br />')
      }
      return null
    },
    isCompanyInformationShown () {
      return this.company && (this.company.name || this.company.description)
    },
    companyDescription () {
      if (this.company && this.company.description) {
        return this.company.description.replace(/\n/g, '<br />')
      }
      return null
    },
    lightboxImages: function () {
      if (!this.propertiesDetails || !this.propertiesDetails.properties_images) return null

      return this.propertiesDetails.properties_images.map(url => {
        return {
          thumb: url,
          src: url
        }
      })
    }
  },
  created () {
    this.propertyDetails(this.$route.params)
    this.favoriteExist(this.$route.params.id)
  },
  methods: {
    ...mapActions('propertyClient', ['propertyDetails', 'favoriteAdd', 'favoriteExist', 'browseHistory']),
    sanitize: function (text) {
      if (!text) return text
      return text.replace(/\n/g, '<br />')
    },
    favoriteProperty: function (id) {
      const data = { id: id }
      this.favoriteAdd(data)
    },
    failBot () {
    },
    iconBefore () {
      const buttonBefore = `.chatboticon::before {background: url(${require('@/assets/img/aitalk_img.png')}) no-repeat }`
      const style = document.createElement('style')
      style.type = 'text/css'
      this.$el.appendChild(style)
      style.innerHTML = buttonBefore
    },
    contactUs: function (name) {
      this.$router.push({ name: 'Client Contact', query: { name: name }, params: { lang: this.$route.params.lang } })
    },
    tallClass: function (image) {
      let img = null
      img = new Image()
      img.src = image
      if (img.height < img.width) {
        return 'thumb-box'
      } else {
        return 'thumb-box tall'
      }
    },
    returnList () {
      if (this.isRentalPropertyDetail) {
        this.$router.push({
          name: 'rental-property-list',
          params: {
            lang: this.$route.params.lang,
            type: this.$route.params.type.replace('-detail', '-list')
          }
        })
      } else {
        this.$router.push({ name: 'Client Property List' })
      }
    },
    updatePropertyDetailHeight () {
      const innerDOM = document.getElementById('property-detail_inner')
      const wrapperDOM = document.getElementById('property-detail_wrapper')
      const outerDOM = document.getElementById('property-detail_outer_wrapper')
      if (!innerDOM || !wrapperDOM || !outerDOM) {
        return
      }
      if (wrapperDOM.offsetHeight < innerDOM.offsetHeight) {
        outerDOM.style.height = innerDOM.offsetHeight + 'px'
      } else {
        outerDOM.style.height = ''
      }
    },
    onResize (e) {
      // work around that resize adds relative
      document.getElementById('property-detail_inner').style.position = null
      this.updatePropertyDetailHeight()
    },
    openLightBox: function (index) {
      this.$refs.lightbox.showImage(index)
    }
  },
  mounted: function () {
    this.iconBefore()
  },
  beforeUpdate: function () {
    this.iconBefore()
  },
  updated: function () {
  },
  beforeDestroy () {
  },
  watch: {
    propertiesDetails: function (val) {
      // TODO: frontend/src/router/index.js でもデフォルトタイトルをハードコーディングしているので共通化したい
      document.title = `${val.property_name} | GLOCALY JAPAN`
    }
  }
}
</script>

<style scoped lang="scss">
.label {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .8);
  color: white;
  padding: 2px 10px;
}
</style>
